var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnabled)?_c('img',{attrs:{"src":_vm.trackingUrl,"id":"__tms_pc","height":"1","width":"1","alt":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }